export const PRIMARY = "#157CFC"
export const LIGHT_BLUE = "#F1F7FE"
export const AUTH_PAGE_BG = "#FFFFFF"
export const DOT_PASSIVE = "#BFDBFF"
export const BORDER_COLOR = "#F2F2F2"
export const MAIN_PAGE_BG = "#F1F1F1"
export const NAV_PANEL_BG = "#10223A"
export const LEFT_PANEL_ACTIVE = "#7D8DA0"

export const INPUT_LABEL_BLUR = "#757575"
export const GRID_HEADER_ITEM = "#838383"
export const WATSAPP_ACTIVE = "#22D954"
export const NOTIFICATION_ICONS_OFF = "#8E8E8E"
export const NOTIFICATION_ICONS_ACTIVE = "#22BC4D"
export const SMS_ICON = "#6E6E6E"
export const CHECKBOX_BORDER_COLOR = "#EDEDED"
export const DELETE_COLOR = "#FF0000"
export const GRAY_COLOR = "#9B9B9B"
export const RADIO_BG = "#F5F7F9"
export const CHECK_BG = "#F5F7F9"
export const LEFT_DRAWER_COLOR = "#F1F1F1"
export const FLOW_PAGE_BG = "#F7F7FA"
export const MULTILINE_INPUT_BG = "#F7F7FA"
export const DISABLED_COLOR = "grey"

export const USER_STATUS_MAP = new Map([
  ["online", "#6dbf66"],
  ["away", "#DEB21D"],
  ["offline", "#ED1212"]
])

export const GREENISH = "#22D954"
export const REDISH = "#FF0000"
export const ORANGISH = "#F29339"
